module.exports = __webpack_public_path__ + "img/flash.5f175747.png";